export enum EntityQueryKey {
  User = 'user',
  Client = 'client',
  Employee = 'employee',
  Document = 'document',
  Signer = 'signqueue',
  Region = 'dictionary/region',
  Passport = 'passport',
  Certificate = 'certificate',
  Snils = 'snils',
  Verification = 'verification',
  VerifyType = 'dictionary/verify_type',
  VerifyingData = 'dictionary/verifying_data',
}

export enum DataTypeQueryKey {
  Table = 'table',
  Autocomplete = 'autocomplete',
}
